<template>
  <v-sheet class="button-group" id="meeting-indicator">
    <v-icon v-if="recordingStore.isOn" class="ml-1 recording" icon="msf:radio_button_checked" />
    <a-icon :name="networkIcon" :width="24" :height="24" class="ml-1 mr-1" />
    <div class="divider"></div>
    <v-btn
      v-if="user.profile.microphone !== 'hidden'"
      class="button"
      :prepend-icon="`msf:mic${user.profile.microphone === 'on' ? '' : '_off'}`"
      v-bind="buttonProps"
      @click="user.profile.microphone === 'on' ? mute('audio') : unmute('audio')"
      :data-wml-speech-command="$t(`meeting.commands.${user.profile.microphone === 'on' ? 'mute' : 'unmute'}`)"
    >
      {{ $t('meeting.configuration.mic') }}
    </v-btn>
    <template v-if="!mobile">
      <v-icon-btn
        icon="msf:keyboard_arrow_down"
        class="button-icon"
        :rounded="4"
        @click="deviceMenuOpened = !deviceMenuOpened"
      />
      <v-menu :close-on-content-click="false" :offset="[10, 0]" activator="#leave-button" v-model="deviceMenuOpened">
        <v-sheet color="#FFFFFF">
          <meeting-device-menu />
        </v-sheet>
      </v-menu>
    </template>
    <v-btn
      class="button"
      v-if="user.profile.camera !== 'hidden'"
      :prepend-icon="`msf:videocam${user.profile.camera === 'on' ? '' : '_off'}`"
      v-bind="buttonProps"
      @click="user.profile.camera === 'on' ? mute('video') : unmute('video')"
      :data-wml-speech-command="$t(`meeting.commands.camera${user.profile.camera === 'on' ? 'On' : 'Off'}`)"
    >
      {{ $t('meeting.configuration.camera') }}
    </v-btn>
    <div class="divider"></div>
    <meeting-participant-menu />
    <meeting-chat-menu />
  </v-sheet>
</template>

<script setup>
import {computed, onMounted, onUnmounted, ref} from 'vue'
import {useSessionStore, useUserStore} from '@/stores'
import {useRecordingStore} from '@/stores'
import {useMuteUnmute} from '@/procedures/useMuteUnmute'
import {useDisplay} from 'vuetify'
const user = useUserStore()
const recordingStore = useRecordingStore()
const session = useSessionStore()
const {mute, unmute} = useMuteUnmute()
const buttonProps = {
  stacked: true,
  density: 'compact',
  size: 'small',
  variant: 'flat',
  rounded: 4,
}
const networkIconMapping = {
  good: 'connection-good',
  average: 'connection-average',
  poor: 'connection-poor',
  offline: 'connection-poor',
}
const networkIcon = computed(() => networkIconMapping[user.qualityNetwork] ?? 'connection-average')
const deviceMenuOpened = ref(false)
const {platform, xs} = useDisplay()
const mobile = computed(() => (platform.value.android && platform.value.ios) || xs.value)
onMounted(() => {
  session.startTimer()
})

onUnmounted(() => {
  session.stopTimer()
})
</script>

<style lang="scss" scoped>
.recording {
  color: #d83737;
  animation: 1s pulse linear infinite;
}
</style>
<style lang="scss" scoped>
@import '@/scss/button-group';
</style>
